import { RoundedBox } from "@react-three/drei";
import { getTexture, BUMP } from "./textures";

const Mat = ({ c, r, m, e, ei, t, tr }) => {
  const map = getTexture(t, tr);
  return (
    <meshStandardMaterial
      color={c}
      roughness={r}
      metalness={m}
      emissive={e || "#000000"}
      emissiveIntensity={e ? ei : 1}
      map={map}
      bumpMap={map}
      bumpScale={map ? BUMP[t] : 1}
    />
  );
};

export const Box = ({ p, s, c, r = 0.85, m = 0, e, ei = 1, rot, shadow = true, t, tr, round, children }) =>
  round ? (
    <RoundedBox args={s} radius={round} smoothness={3} position={p} rotation={rot} castShadow={shadow} receiveShadow>
      <Mat c={c} r={r} m={m} e={e} ei={ei} t={t} tr={tr} />
      {children}
    </RoundedBox>
  ) : (
    <mesh position={p} rotation={rot} castShadow={shadow} receiveShadow>
      <boxGeometry args={s} />
      <Mat c={c} r={r} m={m} e={e} ei={ei} t={t} tr={tr} />
      {children}
    </mesh>
  );

export const Cyl = ({ p, a, c, r = 0.8, m = 0, e, ei = 1, rot, shadow = true, t, tr }) => (
  <mesh position={p} rotation={rot} castShadow={shadow} receiveShadow>
    <cylinderGeometry args={a} />
    <Mat c={c} r={r} m={m} e={e} ei={ei} t={t} tr={tr} />
  </mesh>
);

export const Ball = ({ p, rad, c, r = 0.8, m = 0, e, ei = 1, sc, seg = 24, t, tr }) => (
  <mesh position={p} scale={sc} castShadow receiveShadow>
    <sphereGeometry args={[rad, seg, seg]} />
    <Mat c={c} r={r} m={m} e={e} ei={ei} t={t} tr={tr} />
  </mesh>
);

export const Caps = ({ p, a, c, r = 0.8, rot, t = "fabric", tr = [2, 2] }) => (
  <mesh position={p} rotation={rot} castShadow receiveShadow>
    <capsuleGeometry args={[a[0], a[1], 6, 12]} />
    <Mat c={c} r={r} m={0} t={t} tr={tr} />
  </mesh>
);
